<template lang="pug">
  .container(id="customer-reservation-calendar")
    calendar-dialog(
      ref="dialog",
      typeDialog="customer",
      @getCalendar="getCalendar",
      @forceUpdate="forceUpdate",
    )
    el-row.right(style="padding: 20px 0px;")
      el-button(type="primary",  @click="goReservation") ทำการจอง
    .header-container
      el-badge(v-bind:is-dot="dotLeft")
        el-button(icon="el-icon-arrow-left", @click="goPreviousMonth", circle)
      .header {{ calendarName }}
      el-badge(v-bind:is-dot="dotRight")
        el-button(icon="el-icon-arrow-right",  @click="goNextMonth", circle)
    vue-tuicalendar(
      ref="calendar",
      :options="options",
      :schedules="calendarSchedules",
      @before-create-schedule="beforeCreateSchedule",
      @click-schedule="clickSchedule",
      style="height: 600px; width: 100%; margin-bottom: 100px",
    )
    span(v-if="historyList" style="margin-bottom: 24px;") ประวัติการจอง
    patient-history-table(v-if="historyList" :list="historyList" :getHistoryList="getHistoryList" :patientId="patientId")
</template>

<style lang="scss" scoped>

  .container {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
  }

  .right {
    text-align: right;
  }

  .header {
    font-size: 30px;
    font-weight: bold;
  }

  .header-container {
    width: 100%;
    display: flex;
    flex-direction: row;
    margin-bottom: 10px;
    justify-content: space-between;
  }

  .el-button.is-circle {
    border-radius: 50%;
    padding: 12px;
    font-size: 25px;
    font-weight: 900;
  }

</style>

<style lang="scss">
  .tui-full-calendar-weekday-schedule-title {
    display: flex;
    align-items: center;
  }

  .tui-full-calendar-month-week-item .tui-full-calendar-today .tui-full-calendar-weekday-grid-date-decorator {
    background: #5489FF;
  }

  .el-badge__content {
    background-color: #FF577F;
  }
</style>

<script>
import moment from 'moment'
import CalendarDialog from '@/components/shared/CalendarDialog'
import PatientHistoryTable from '@/components/patient/PatientHistoryTable'
import CalendarScheduleModel from '@/model/CalendarScheduleModel'
import { GenericAPIHandler } from '@/components/shared/GenericAPIHandler'

export default {
  name: 'PatientCalendar',
  mixins: [GenericAPIHandler],
  components: {
    CalendarDialog,
    PatientHistoryTable,
  },
  props: {
    patientId: {
      type: Number,
      required: true,
    },
  },
  mounted () {
    this.getCalendar()
    this.getHistoryList()
  },
  data () {
    return {
      monthMoment: moment().format(),
      calendarSchedules: [],
      reservations: [],
      options: {
        defaultView: 'month',
        isReadOnly: true,
        taskView: true,
        scheduleView: true,
        useCreationPopup: false,
        useDetailPopup: false,
        theme: {
          'common.holiday.color': '#000000',
          'common.today.color': '#f00',
          'month.holidayExceptThisMonth.color': '#dfdfdf',
          'month.dayExceptThisMonth.color': '#dfdfdf',
          'month.dayname.borderLeft': 'none',
          'month.dayname.fontSize': '18px',
        },
        template: {
          allday (schedule) {
            let shiftType
            if (schedule.raw.shiftType === 'day') {
              shiftType = `<img src='https://storage.healthathome.in.th/ebe33da4-6df7-4aae-9725-39099ba00701.svg' width="16px" height="16px" />`
            } else {
              shiftType = `<img src='https://storage.healthathome.in.th/74ec3e15-7a26-47d6-8403-79a194bb9a2f.svg' width="14px" height="14px" />`
            }
            switch (schedule.raw.status) {
              case 'booking':
                return `<div class="el-badge__content" style="border: none; margin-right: 5px"> ${schedule.raw.numberOfAcceptCandidates} </div> ${shiftType} <span style="font-size: 16px; margin-left: 2px">${schedule.title.split(' ')[0]} <span style="opacity: 0.5;">(${schedule.title.split('(')[1]}</span></span>`
              case 'matched':
                return `<img src=${require('@/assets/icon/person-white.svg')} width="10px" height="10px" style="margin-right: 2px" /> &nbsp; ${shiftType} <span style="font-size: 16px; margin-left: 4px">${schedule.title.split('(')[0]} <span style="opacity: 0.5;">(${schedule.title.split('(')[1]}</span></span>`
              case 'reserved':
                return `${shiftType} <span style="font-size: 16px; margin-left: 4px"">${schedule.title.split(' ')[0]} <span style="opacity: 0.5;">(${schedule.title.split('(')[1]}</span></span>`
            }
          },
          monthMoreTitleDate (date, dayShort) {
            const dayFormatFullName = () => {
              switch (dayShort) {
                case 'อา.':
                  return 'อาทิตย์'
                case 'จ.':
                  return 'จันทร์'
                case 'อ.':
                  return 'อังคาร'
                case 'พ.':
                  return 'พุธ'
                case 'พฤ.':
                  return 'พฤหัส'
                case 'ศ.':
                  return 'ศุกร์'
                case 'ส.':
                  return 'เสาร์'
              }
            }
            const dayFullName = dayFormatFullName(dayShort)
            return `${moment(date, 'YYYY.MM.DD').format('DD')} ${dayFullName}`
          },
        },
        month: {
          visibleScheduleCount: 3,
          daynames: ['อา.', 'จ.', 'อ.', 'พ.', 'พฤ.', 'ศ.', 'ส.'],
          startDayOfWeek: 1,
          narrowWeekend: false,
        },
      },
      historyList: null,
      currentSchedule: null,
    }
  },
  computed: {
    calendarName () {
      return moment(this.monthMoment).format('MMMM') + ' ' + moment(this.monthMoment).format('YYYY')
    },
    dotRight () {
      for (let add = 1; add <= 11; add++) {
        for (let i = 0; i < this.calendarSchedules.length; i++) {
          let start = this.calendarSchedules[i] ? moment(this.calendarSchedules[i].start).format('MMMM, YYYY') : ''
          let end = this.calendarSchedules[i] ? moment(this.calendarSchedules[i].end).format('MMMM, YYYY') : ''
          let next = moment(this.monthMoment).add(add, 'months').format('MMMM, YYYY')
          if (start === next || end === next) return true
        }
      }
      return false
    },
    dotLeft () {
      for (let subtract = 1; subtract <= 11; subtract++) {
        for (let i = 0; i < this.calendarSchedules.length; i++) {
          let start = this.calendarSchedules[i] ? moment(this.calendarSchedules[i].start).format('MMMM, YYYY') : ''
          let end = this.calendarSchedules[i] ? moment(this.calendarSchedules[i].end).format('MMMM, YYYY') : ''
          let prev = moment(this.monthMoment).subtract(subtract, 'months').format('MMMM, YYYY')
          if (start === prev || end === prev) return true
        }
      }
      return false
    },
  },
  methods: {
    async getCalendar () {
      try {
        const raw = await this.$api.Patient.calendar(this.patientId)
        await this.$nextTick()
        this.calendarSchedules = []
        for (let i = 0; i < raw.list.length; i++) {
          const scheduleItems = CalendarScheduleModel.fromCalendar(raw.list[i])
          this.calendarSchedules.push(...scheduleItems)
        }
      } catch (error) {
        this.showErrorDialog(error)
      }
    },
    async getHistoryList () {
      try {
        const raw = await this.$api.Reservation.historyList(this.patientId)
        this.historyList = raw
      } catch (error) {
        this.showErrorDialog(error)
      }
    },

    beforeCreateSchedule (e) {
      e.guide.clearGuideElement()
    },
    clickSchedule (e) {
      this.$refs.dialog.update(e.schedule)
      this.currentSchedule = e.schedule
    },
    async forceUpdate () {
      try {
        const raw = await this.$api.Patient.calendar(this.patientId)
        await this.$nextTick()
        this.calendarSchedules = []
        for (let i = 0; i < raw.list.length; i++) {
          const scheduleItems = CalendarScheduleModel.fromCalendar(raw.list[i])
          this.calendarSchedules.push(...scheduleItems)
        }
        const data = raw.list.map(s => CalendarScheduleModel.fromCalendar(s)[0]).filter(s => s.id === this.currentSchedule.id && s.raw.bookingId === this.currentSchedule.raw.bookingId)[0]
        if (data) {
          this.$refs.dialog.update(data)
        }
      } catch (error) {
        this.showErrorDialog(error)
      }
    },
    goPreviousMonth () {
      this.$refs['calendar'].fireMethod('prev', 'month')
      this.monthMoment = moment(this.monthMoment).subtract(1, 'months')
    },
    goNextMonth () {
      this.$refs['calendar'].fireMethod('next', 'month')
      this.monthMoment = moment(this.monthMoment).add(1, 'months')
    },
    goReservation () {
      this.$router.push({ name: 'ReservationCreate', params: { id: this.patientId } })
    },
  },
}
</script>
